// Product cards: hovering (or tapping, on touch) a colour bar swaps the card photo to that colour.
document.addEventListener("pointerover", swap);
document.addEventListener("click", (e) => { if (e.target.closest("[data-swatch]")) { e.preventDefault(); swap(e); } });
function swap(e) {
  const s = e.target.closest("[data-swatch]"); if (!s) return;
  const card = s.closest("[data-product-card]"); const img = card.querySelector("[data-card-img]");
  card.classList.add("has-swatch");
  img.src = s.dataset.image; img.srcset = `${s.dataset.image} 800w, ${s.dataset.image2x} 1600w`;
  card.querySelectorAll("[data-swatch]").forEach((x) => x.classList.toggle("is-active", x === s));
}

// Shopify posts the newsletter and contact forms and renders the thank-you itself (form.posted_successfully?); it takes focus here so
// screen readers announce it. The prototype's fake submit handlers are gone.
document.querySelector("[data-form-done]")?.focus();
